import {
  getResSearchContentResult,
  getResourceTypes,
  getOrganisedResourceTypes
} from '@/api/resources'
import {
  getLocResTypes,
  setLocResTypes,
  removeLocResTypes
} from '@/utils/storage.js'
import {
  getOrganisedMark
} from '@/utils/cookies.js'
import utils from '@/utils/utils'
import constant from '@/api/constant'

String.prototype.contentReplace = function (f, e) { //吧f替换成e
  var reg = new RegExp(f, "g") //创建正则RegExp对象   
  return this.replace(reg, e)
}

const SSO_WEB_URL = process.env.SSO_WEB_URL

const resources = {
  computed: {
    ...mapGetters([
      "host"
    ])
  },
  state: {
    resourcesId: '',
    isCourse: false,
    resourcesTypes: [],
    searchResultText: [],
    searchResultContext: [],

    existSearchFlag: false,
    searchType: 'list', // list-我的资源 object-资源阅读
    searchKeyword: '', // 关键字
    checkedCatalogIndex: '', // 资源目录选中
    isOrganised: false, // 是否机构资源
    sso_web_url: SSO_WEB_URL,
    page:'1',
    pageSize:'20',
    total:"0"
  },
  mutations: {
    setResourcesId: (state, resoureCabpId) => {
      state.resoureCabpId = resoureCabpId
    },
    setExistSearchFlag: (state, existSearchFlag) => {
      state.existSearchFlag = existSearchFlag
    },
    setSearchResultText: (state, searchResultText) => {
      state.searchResultText = searchResultText
    },
    setSearchResultContext: (state, searchResultContext) => {
      state.searchResultContext = searchResultContext
    },
    setSearchType: (state, searchType) => {
      state.searchType = searchType
    },
    setSearchKeyword: (state, searchKeyword) => {
      state.searchKeyword = searchKeyword
    },
    setCheckedCatalogIndex: (state, checkedCatalogIndex) => {
      state.checkedCatalogIndex = checkedCatalogIndex
    },
    setResourcesTypes: (state, content) => {
      state.resourcesTypes = content
    },
    setIsOrganised: (state, content) => {
      state.isOrganised = content
    },
    setIsCourse: (state, content) => {
      state.isCourse = content
    },
    setPage: (state, page) => {
      state.page = page
    },
    setPageSize: (state, pageSize) => {
      state.pageSize = pageSize
    },
    setTotal: (state, total) => {
      state.total = total
    },
  },
  actions: {
    // 资源搜索
    
    getResourcesSearchResult({
      commit,
      state
    }, keyWord) {
      
      let searchType = state.searchType
      let page = state.page
      let pageSize = state.pageSize
      if(searchType=='object'){
        searchType=''
      }
      let searchKeyword = state.searchKeyword
      if(keyWord==''){
        keyWord=searchKeyword
      }
      let searchResoureCabpId = state.resoureCabpId
      if (searchType == ''||searchType == 'img'||searchType == 'text') {
        return new Promise((resolve, reject) => {
          getResSearchContentResult(keyWord, searchResoureCabpId, searchType,page,pageSize).then(response => {
            const resultData = response.data
            let errorInfo = resultData.errorInfo
            let data = resultData.data
            if (errorInfo === 'success') {
              let wordIndex = 1
              commit('setExistSearchFlag', true)
                let newData = []

              //这边对关键词名字定位区分
              for (let i = 0; i < data.totalList.length; i++) {
                let item = data.totalList[i]
                var  content = item.content;
                
               


                if (i > 0) {
                  let beforeItem = data.totalList[i - 1]
                  if (item.catalogId == beforeItem.catalogId) {
                    wordIndex++
                    item['wordIndex'] = wordIndex
                  } else {
                    wordIndex = 1
                    item['wordIndex'] = wordIndex
                  }
                } else {
                  item['wordIndex'] = 1
                }
                let content = item.content
                let positionIndex = item.catalogId + '-' + item.resId + '-' + item.wordIndex
                let replaceContent = '<span class="word">' + keyWord + '</span>'
                let newContent = content.contentReplace(keyWord, replaceContent)
                
                item.content = newContent
                
                var contentIndex = item.content.indexOf("<em>")

               
                if(contentIndex >=20){
                  item.content = "..."+item.content.slice( contentIndex-15,item.content.length)
                }
                item['positionIndex'] = positionIndex

                if (item.searchType == 'img') {

                  let a = item.src.split("!")
                  item.src = process.env.READ_PLATFORM_PATH+'/bookimg'+a[1]

                }
                newData.push(item)
              }
              commit('setTotal', data.total)
              if(page == 1){
                commit('setSearchResultText', resultData.data.lstCatalogs)
                commit('setSearchResultContext', newData)

              }else{
                
                for(let i = 0; i < newData.length; i++){
                  state.searchResultContext.push(newData[i])
                }
                for(let i = 0; i < resultData.data.lstCatalogs.length; i++){
                  state.searchResultText.push(resultData.data.lstCatalogs[i])
              }
              commit('setSearchResultText', state.searchResultText)
              commit('setSearchResultContext', state.searchResultContext)
              }

            } else {
              commit('setSearchResultText', [])
              commit('setSearchResultContext', [])
              commit('setTotal', 0)
              commit('setPage', 1)
              commit('setExistSearchFlag', false)
            }
            resolve(resultData)
          }).catch(error => {
            commit('setSearchResultText', [])
            commit('setSearchResultContext', [])
            commit('setExistSearchFlag', false)
            reject(error)
          })
        })
      } else {
        return new Promise((resolve, reject) => {
          let resultData = {
            data: null,
            errorInfo: '',
            otherData: ''
          }
          resolve(resultData)
        })
      }
    },
    // 资源类型列表
    handleResourceTypes({
      commit,
      state
    }, isOrganised, userToken) {
      let allTypeList = constant.categoryList
      let myTypeList = []
      let resourceTypeList = []
      getResourceTypes().then(res => {
        myTypeList = res.data.data
        for (let a = 0; a < allTypeList.length; a++) { //全部品类
          for (let m = 0; m < myTypeList.length; m++) { //我的品类
            if (myTypeList[m] == allTypeList[a].code) {
              resourceTypeList.push(allTypeList[a])
            }
          }
        }
      })
      if (isOrganised) {
        return new Promise((resolve, reject) => {
          getOrganisedResourceTypes().then(mecRes => {
            let mecResultData = mecRes.data
            let mecErrorInfo = mecResultData.errorInfo
            let tempList = []
            if (mecErrorInfo === 'success') {
              let resData = mecResultData.data
              for (let temp of resData) {
                let tempOption = utils.getOptionItemInArray(resourceTypeList, 'code', temp)
                if (tempOption) {
                  tempList.push(tempOption)
                }
              }
            } else if (mecErrorInfo === 'notAuthor') {
              tempList = []
            } else {
              tempList = resourceTypeList
            }
            commit('setResourcesTypes', tempList)
            resolve(tempList[0])
          }).catch(error => {
            reject(error)
          })
        })
      } else {
        commit('setResourcesTypes', resourceTypeList)
        return new Promise((resolve, reject) => {
          resolve(resourceTypeList[0])
        })
      }

    },
    //存储关键词
    saveReaourceSearchKeyWord({
      commit,
      state
    }, keyWord) {

    }
  }
}
import { mapGetters } from "vuex";

export default resources



// WEBPACK FOOTER //
// ./src/store/modules/resources.js